import { defineComponent as l, openBlock as d, createBlock as n, unref as o, mergeProps as i, withCtx as r, renderSlot as s } from "vue";
import m from "./ghl-ui.es191.js";
const f = l({
  name: "UIRadioGroup",
  inheritAttrs: !1
}), p = l({
  ...f,
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    value: {
      type: [String, Number, Boolean]
    },
    name: {
      type: String
    },
    size: {
      type: String,
      default: "medium"
    },
    defaultValue: {
      type: [String, Number, Boolean, null]
    }
  },
  emits: ["update:value"],
  setup(e) {
    return (a, t) => (d(), n(o(m), i({
      disabled: e.disabled,
      "default-value": e.defaultValue,
      value: e.value,
      name: e.name
    }, a.$attrs, {
      size: e.size,
      "onUpdate:value": t[0] || (t[0] = (u) => a.$emit("update:value", u))
    }), {
      default: r(() => [
        s(a.$slots, "default")
      ]),
      _: 3
    }, 16, ["disabled", "default-value", "value", "name", "size"]));
  }
}), g = p;
export {
  g as default
};
